import { createContext } from 'react';
import { init } from '@rematch/core';
import createLoadingPlugin from '@rematch/loading';
import immerPlugin from '@rematch/immer';

import { parksData } from './parksData.rematch';

// reports screen models
import performance from 'routes/Reports/models/performance';
import totalGenerationChart from 'routes/Reports/models/totalGenerationChart';
import turbineGenerationChart from 'routes/Reports/models/turbineGenerationChart';
import turbineSummary from 'routes/Reports/models/turbineSummary';
import overviewTotal from 'routes/Reports/models/overviewTotal';
import overviewReleaseChart from 'routes/Reports/models/overviewReleaseChart';
import overviewUnavailableChart from 'routes/Reports/models/overviewUnavailableChart';
import turbineMaintenance from 'routes/Reports/models/turbineMaintenance';
import overviewLogs from 'routes/Reports/models/overviewLogs';
import turbineStatusChart from 'routes/Reports/models/turbineStatusChart';
import parkMaintenance from 'routes/Reports/models/parkMaintenance';
import person from 'routes/Reports/models/person';
import menuBar from 'routes/Reports/models/menuBar';
import vesselData from 'routes/Operations/models/visselData';

// operation screen models
import operations from 'routes/Operations/models/operations';
import turbines from 'routes/Operations/models/turbines';
import powerGrids from 'routes/Operations/models/powerGrids';
import offshorePlatforms from 'routes/Operations/models/offshorePlatforms';
import plantData from 'routes/Operations/models/plantData';
import filter from 'routes/Operations/models/filter';
import powerPrice from 'routes/Operations/models/powerPrice';
import weather from 'routes/Operations/models/weather';

// common model
import { logTabs } from 'models/logTabs.js';
import { routing } from 'models/routing';
import { webSocket } from 'models/webSocket';
import { account } from 'models/account';
import { appData } from 'models/appData';
import { systemStatus } from 'models/systemStatus';

//websocket
import { webSocketMiddleware } from 'common/webSocketMiddleware';

import { createStoreHook, createDispatchHook, createSelectorHook } from 'react-redux';

export const RematchContext = createContext(null);

export const useRematchStore = createStoreHook(RematchContext);
export const useRematchDispatch = createDispatchHook(RematchContext);
export const useRematchSelector = createSelectorHook(RematchContext);

/**
 * rematch loading plugin.
 * Reference: https://rematch.github.io/rematch/#/plugins/loading
 */
const loadingPlugin = createLoadingPlugin({
    name: 'loading',
    blacklist: [],
});

export const createRematchStore = () =>
    init({
        models: {
            parksData,
            routing,
            performance,
            totalGenerationChart,
            turbineGenerationChart,
            turbineSummary,
            overviewTotal,
            overviewReleaseChart,
            overviewUnavailableChart,
            turbineMaintenance,
            overviewLogs,
            turbineStatusChart,
            parkMaintenance,
            person,
            menuBar,
            vesselData,
            logTabs,
            operations,
            turbines,
            powerGrids,
            offshorePlatforms,
            plantData,
            filter,
            powerPrice,
            weather,
            webSocket,
            account,
            appData,
            systemStatus,
        },
        redux: {
            middlewares: [webSocketMiddleware],
        },
        plugins: [loadingPlugin, immerPlugin()],
    });

export const rematchStore = createRematchStore();
